import React, { useContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import SystemService from '../../../data/system-service';
import DataContext from '../../../data/data-context';

const ConfigContainer = () => {
    const { setSystemSettings } = useContext(DataContext);
    useEffect(() => {
        SystemService.getSystemSettings().then((res) => {
            setSystemSettings(res);
        });
    }, []);

    return (
        <div>
            <Outlet />
        </div>
    );
};

export default ConfigContainer;
